/* SSS facets loader: native AJAX facets + Safari-safe initialization guards */
(function(){
  var source=document.currentScript&&document.currentScript.src;
  if(!source)return;
  function sibling(name){
    var u=new URL(source,window.location.href);
    u.pathname=u.pathname.replace(/\/[^/]+$/, '/'+name);
    u.search='';u.hash='';return u.toString();
  }

  if(!document.querySelector('link[href*="sss-smart-filters-v3.css"]')){
    var css=document.createElement('link');
    css.rel='stylesheet';css.href=sibling('sss-smart-filters-v3.css');document.head.appendChild(css);
  }

  var core=document.createElement('script');
  core.src=sibling('facets-core-sss.js');core.async=false;
  core.onload=function(){
    // The core calls this function from multiple lifecycle paths. Guard each facet slider so
    // repeated filter renders do not stack Swiper instances and MutationObservers.
    window.initFacetsSwiper=function(){
      document.querySelectorAll('.facets__display.swiper').forEach(function(slider){
        if(slider.swiper || slider.dataset.sssFacetSwiperReady==='1') return;
        slider.dataset.sssFacetSwiperReady='1';

        new Swiper(slider,{
          slidesPerView:'auto',
          slidesPerGroup:1,
          spaceBetween:24,
          navigation:{
            nextEl:slider.querySelector('.swiper-button-next'),
            prevEl:slider.querySelector('.swiper-button-prev')
          },
          allowTouchMove:true
        });

        var prevBtn=slider.querySelector('.swiper-button-prev');
        if(!prevBtn)return;
        var updateClass=function(){
          slider.classList.toggle('swiper-prev-enabled',prevBtn.getAttribute('aria-disabled')!=='true');
        };
        updateClass();
        if(prevBtn.dataset.sssFacetObserverReady==='1') return;
        prevBtn.dataset.sssFacetObserverReady='1';
        new MutationObserver(updateClass).observe(prevBtn,{attributes:true,attributeFilter:['aria-disabled']});
      });
    };

    // Collection templates already load the shared filter enhancer. Avoid a second execution.
    // Search/other templates without that script still get their own enhancer.
    if(!document.querySelector('script[src*="sss-smart-filters-v3.js"]')){
      var smart=document.createElement('script');
      smart.src=sibling('sss-smart-filters-v3.js');smart.async=false;document.head.appendChild(smart);
    }
    if(document.readyState!=='loading'){
      setTimeout(function(){try{window.initFacetsSwiper&&window.initFacetsSwiper();}catch(e){}},0);
    }
  };
  document.head.appendChild(core);
})();
